(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('LenderSearch', LenderSearch);

    LenderSearch.$inject = ['$resource'];

    function LenderSearch($resource) {
        var resourceUrl =  'api/_search/lenders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
